const TYPES_MAP = {
  CARD: 'LISTING CARD',
  COMPACT: 'LISTING CARD COMPACT',
}

export default TYPES_MAP
